import { render, staticRenderFns } from "./editOwnersTableRow.vue?vue&type=template&id=74e6d7cb"
import script from "./editOwnersTableRow.vue?vue&type=script&lang=js"
export * from "./editOwnersTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports